import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [state, setState] = useState({ status: "checking" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") setState({ status: "paid", data });
        else if (tries > 20) setState({ status: "timeout", data });
        else { setTries((n) => n + 1); t = setTimeout(poll, 2000); }
      } catch { setState({ status: "error" }); }
    };
    poll();
    return () => clearTimeout(t);
  }, [sessionId, tries]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="bento-card p-10 max-w-md text-center">
        {state.status === "checking" && <><Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" /><h1 className="font-display text-3xl font-bold mb-2">Confirming payment…</h1><p className="text-muted-foreground">Hold tight, Stripe is finalizing.</p></>}
        {state.status === "paid" && <><CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" /><h1 className="font-display text-4xl font-black mb-2">Paid</h1><p className="text-muted-foreground mb-6">Nice work — job invoice marked paid.</p><Link to="/app"><Button className="rounded-sm">Back to dashboard</Button></Link></>}
        {state.status === "timeout" && <><h1 className="font-display text-3xl font-bold mb-2">Still processing</h1><p className="text-muted-foreground mb-4">We'll update your dashboard when Stripe confirms.</p><Link to="/app"><Button className="rounded-sm">Go to dashboard</Button></Link></>}
        {state.status === "error" && <><XCircle className="w-14 h-14 text-destructive mx-auto mb-4" /><p className="text-muted-foreground mb-4">Could not verify. Please refresh the estimate.</p><Link to="/app"><Button className="rounded-sm">Dashboard</Button></Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="bento-card p-10 max-w-md text-center">
        <XCircle className="w-14 h-14 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-display text-3xl font-bold mb-2">Payment cancelled</h1>
        <p className="text-muted-foreground mb-6">No charge was made. You can resend the link anytime.</p>
        <Link to="/app"><Button className="rounded-sm">Back to dashboard</Button></Link>
      </div>
    </div>
  );
}
